<script>
import FooterBottom from './FooterBottom'
export default {
  name: 'AppBaseR',
  components: { FooterBottom }
}
</script>
<template>
  <div id="app">
    <content>
      <div class="container-xl main-gradient main-blockr mt-5">
        <router-view />
      </div>
    </content>
    <FooterBottom />
  </div>
</template>

<style>
@media (max-width: 500px) {
  body {
    background: #0873D6;
  }
  footer {
    width:100%;
    margin: auto;
  }
  .main-blockr{
    border-radius:10px ;
    width:100%;
    min-height:434px;
  }
}

@media (max-width: 767px) {
  html {
    height: 100%;
  }
  body {
    background-image: linear-gradient(135deg, #0873D6 0%, #3ADFFF 100%);
    min-height: 100%;
  }

}

@media (min-width:767px) {
  footer {
    width:535px;
    margin: auto;
  }
  .main-blockr{
    border-radius:10px ;
    width:535px;
    min-height:474px;
  }
  .main-gradient{
    background-image: linear-gradient(135deg, #0873D6 0%, #3ADFFF 100%);
  }
}
</style>
